module.exports = __webpack_public_path__ + "static/media/emailCampaigns.6f3d210b.svg";